import ErrorAlert from '@quicktools/shared-components/components/core/ErrorAlert';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

import useStore from '../../../services/store';

import useStyles from './styles';

function Alerts() {
  const classes = useStyles();
  const validationError = useStore((state) => state.validationError);
  const genericError = useStore((state) => state.genericError);
  const showValidationError = useStore((state) => state.showValidationError);
  const showGenericError = useStore((state) => state.showGenericError);
  const { t } = useTranslation();
  const hideGenericError = useCallback(() => showGenericError(''), []);
  const hideValidationError = useCallback(() => showValidationError(false), []);

  return (
    <>
      {validationError && (
        <ErrorAlert
          className={classes.alert}
          description={t('editor.invalidFormAlert')}
          onClose={hideValidationError}
        />
      )}

      {genericError && (
        <ErrorAlert
          className={classes.alert}
          description={genericError}
          onClose={hideGenericError}
        />
      )}
    </>
  );
}
export default Alerts;
